import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoItsFor() {
  return <section className="bg-dark py-20 md:py-32 px-5" data-id="element-421">
      <div className="max-w-wide mx-auto" data-id="element-422">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-423">
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white leading-tight" data-id="element-424">
            ¿Es para ti?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-3xl mx-auto" data-id="element-425">
          {/* For you */}
          <motion.div className="bg-money/10 border-2 border-money/25 rounded-2xl p-7 md:p-8" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} viewport={{
          once: true,
          margin: '-40px'
        }} data-id="element-426">
            <h3 className="font-display text-lg font-bold text-money mb-6 flex items-center gap-2" data-id="element-427">
              <CheckIcon className="w-5 h-5" data-id="element-428" /> Esto es para ti si:
            </h3>
            <div className="space-y-4" data-id="element-429">
              <div className="flex items-start gap-3" data-id="element-430">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-money/20 flex items-center justify-center mt-0.5" data-id="element-431">
                  <CheckIcon className="w-3.5 h-3.5 text-money" data-id="element-432" />
                </div>
                <p className="font-sans text-white/80 leading-relaxed" data-id="element-433">
                  Quieres formar hábitos y valores{' '}
                  <strong className="text-white" data-id="element-434">sin campo de batalla</strong>.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-435">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-money/20 flex items-center justify-center mt-0.5" data-id="element-436">
                  <CheckIcon className="w-3.5 h-3.5 text-money" data-id="element-437" />
                </div>
                <p className="font-sans text-white/80 leading-relaxed" data-id="element-438">
                  Estás listo para ser consistente{' '}
                  <strong className="text-white" data-id="element-439">7 minutos por semana</strong>.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Not for you */}
          <motion.div className="bg-dark-card border-2 border-urgency/20 rounded-2xl p-7 md:p-8" initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} viewport={{
          once: true,
          margin: '-40px'
        }} data-id="element-440">
            <h3 className="font-display text-lg font-bold text-urgency mb-6 flex items-center gap-2" data-id="element-441">
              <XIcon className="w-5 h-5" data-id="element-442" /> No es para ti si:
            </h3>
            <div className="space-y-4" data-id="element-443">
              <div className="flex items-start gap-3" data-id="element-444">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-urgency/15 flex items-center justify-center mt-0.5" data-id="element-445">
                  <XIcon className="w-3.5 h-3.5 text-urgency" data-id="element-446" />
                </div>
                <p className="font-sans text-white/50 leading-relaxed" data-id="element-447">
                  Buscas «hazte rico» o inversiones milagro.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-448">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-urgency/15 flex items-center justify-center mt-0.5" data-id="element-449">
                  <XIcon className="w-3.5 h-3.5 text-urgency" data-id="element-450" />
                </div>
                <p className="font-sans text-white/50 leading-relaxed" data-id="element-451">
                  Quieres resultados sin aplicar reglas.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}